export const empAttreportApi = {
    heading:[
        {
            head:"SL"
        },
        {
            head:"Name"
        },
        {
            head:"ID"
        },
        {
            head:"Designation"
        },
        {
            head:"Date"
        },
        {
            head:"Out Time"
        },
        {
            head:"Time Late"
        },
        {
            head:"Type"
        }
    ],
    data:[
       {
        sl:1138,
        name:"Safayet",
        id:2211261138,
        designation:"manager",
        date:"15-02-2023",
        intime:"45pm", 
        outtime:"15:00",
        type:"good",
       },
       {
        sl:1139,
        name:"Anik",
        id:2211261138,
        designation:"manager",
        date:"15-02-2023",
        intime:"45pm", 
        outtime:"15:00",
        type:"excelent",
       },
       {
        sl:1139,
        name:"Anik",
        id:2211261138,
        designation:"manager",
        date:"15-02-2023",
        intime:"45pm", 
        outtime:"15:00",
        type:"excelent",
       },
       {
        sl:1139,
        name:"Anik",
        id:2211261138,
        designation:"manager",
        date:"15-02-2023",
        intime:"45pm", 
        outtime:"15:00",
        type:"excelent",
       },
       {
        sl:1139,
        name:"Anik",
        id:2211261138,
        designation:"manager",
        date:"15-02-2023",
        intime:"45pm", 
        outtime:"15:00",
        type:"excelent",
       },
       {
        sl:1139,
        name:"Anik",
        id:2211261138,
        designation:"manager",
        date:"15-02-2023",
        intime:"45pm", 
        outtime:"15:00",
        type:"excelent",
       },
       {
        sl:1139,
        name:"Anik",
        id:2211261138,
        designation:"manager",
        date:"15-02-2023",
        intime:"45pm", 
        outtime:"15:00",
        type:"excelent",
       },
       {
        sl:1139,
        name:"Anik",
        id:2211261138,
        designation:"manager",
        date:"15-02-2023",
        intime:"45pm", 
        outtime:"15:00",
        type:"excelent",
       },
       {
        sl:1139,
        name:"Anik",
        id:2211261138,
        designation:"manager",
        date:"15-02-2023",
        intime:"45pm", 
        outtime:"15:00",
        type:"excelent",
       },
       {
        sl:1139,
        name:"Anik",
        id:2211261138,
        designation:"manager",
        date:"15-02-2023",
        intime:"45pm", 
        outtime:"15:00",
        type:"excelent",
       },
       {
        sl:1139,
        name:"Anik",
        id:2211261138,
        designation:"manager",
        date:"15-02-2023",
        intime:"45pm", 
        outtime:"15:00",
        type:"excelent",
       },
       {
        sl:1139,
        name:"Anik",
        id:2211261138,
        designation:"manager",
        date:"15-02-2023",
        intime:"45pm", 
        outtime:"15:00",
        type:"excelent",
       },
       {
        sl:1139,
        name:"Anik",
        id:2211261138,
        designation:"manager",
        date:"15-02-2023",
        intime:"45pm", 
        outtime:"15:00",
        type:"excelent",
       },
       {
        sl:1139,
        name:"Anik",
        id:2211261138,
        designation:"manager",
        date:"15-02-2023",
        intime:"45pm", 
        outtime:"15:00",
        type:"excelent",
       },
       {
        sl:1139,
        name:"Anik",
        id:2211261138,
        designation:"manager",
        date:"15-02-2023",
        intime:"45pm", 
        outtime:"15:00",
        type:"excelent",
       },
   
       
    ]
}